import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EditOutlined, PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  Input,
  Typography,
  Grid,
  message,
  Modal,
} from 'antd';
import TransferInput from './TransferInput';

const { TextArea } = Input;

const DatosGenerales = ({ selectedRow }) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [form] = Form.useForm();
  const [formFundamentoLegal] = Form.useForm();

  const [fundamentos, setFundamentos] = useState([]);
  const [tempFundamentos, setTempFundamentos] = useState([]);

  const includeFundamento = ({ fundamentosArray }) => {
    let temp = [];
    fundamentosArray.forEach((item) => {
      const data = fundamentos.find((element) => parseInt(element, 10) === parseInt(item, 10));
      if (!data) temp = [...temp, item];
    });
    setTempFundamentos(temp);
  };

  const callback = ({ key }) => includeFundamento({ fundamentosArray: key });

  const setFieldsForm = () => {
    form.setFieldsValue({
      nombre: selectedRow?.nombre,
      homoclave: selectedRow?.homoclave,
      modalidad: selectedRow?.modalidad,
      la_inspeccion_es: selectedRow?.la_inspeccion_es,
      inspeccion: selectedRow?.inspeccion,
      excenta: selectedRow?.excenta,
      objetivo: selectedRow?.objetivo,
      motivo_de_la_inspeccion: selectedRow?.motivo_de_la_inspeccion,
      fundamentos_juridicos: selectedRow?.fundamentos_juridicos,
    });

    setFundamentos(selectedRow?.fundamentos_juridicos);
  };

  useEffect(() => {
    setFieldsForm();
  }, [selectedRow]);

  return (
    <>
      <Tabs defaultActiveKey="1" forceRender type="card">
        <Tabs.TabPane tab="Datos Generales" key="1">
          <Form
            style={{ marginTop: '10px' }}
            layout="vertical"
            form={form}
            name="datos-generales"
            defaultValue={{
              nombre: selectedRow?.nombre,
              homoclave: selectedRow?.homoclave,
              modalidad: selectedRow?.modalidad,
              la_inspeccion_es: selectedRow?.la_inspeccion_es,
              inspeccion: selectedRow?.inspeccion,
              excenta: selectedRow?.excenta,
              objetivo: selectedRow?.objetivo,
              motivo_de_la_inspeccion: selectedRow?.motivo_de_la_inspeccion,
              fundamentos_juridicos: selectedRow?.fundamentos_juridicos,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Nombre" name="nombre">
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Homoclave" name="homoclave">
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Modalidad" name="modalidad">
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Tipo de inspección" name="homoclave">
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="La inspección es:" name="la_inspeccion_es">
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="¿La inspección está excenta de la Ley de Fomento?">
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item label="Objetivo" name="objetivo">
                  <TextArea rows={4} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item label="Motivo de inspección" name="motivo_de_la_inspeccion">
                  <TextArea rows={4} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item style={{ textAlign: 'right' }}>
                  <Button
                    type="link"
                    icon={<PlusOutlined />}
                    onClick={() => setVisible(true)}
                  >
                    Agregar Fundamento Legal
                  </Button>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item label="Fundamentos legales">
                  <TransferInput
                    fundamentosArray={selectedRow.fundamentos_juridicos}
                    callback={callback}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Sectores" key="2">
          <Card>
            <Typography.Title level={4}>Sectores</Typography.Title>
          </Card>
        </Tabs.TabPane>
      </Tabs>
      <Modal
        title="Fundamento Legal"
        open={visible}
        // onOk={handleOk}
        // confirmLoading={confirmLoading}
        onCancel={() => setVisible(false)}
      >
        <Form
          layout="vertical"
          form={formFundamentoLegal}
          name="datos-generales"
        >
          <Row gutter={[10, 15]}>
            <Col xs={24} sm={24} md={24}>
              <Form.Item label="Nombre">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

DatosGenerales.propTypes = {
  selectedRow: PropTypes.shape({
    nombre: PropTypes.string,
    homoclave: PropTypes.string,
    modalidad: PropTypes.string,
    la_inspeccion_es: PropTypes.string,
    inspeccion: PropTypes.string,
    excenta: PropTypes.string,
    objetivo: PropTypes.string,
    motivo_de_la_inspeccion: PropTypes.string,
    fundamentos_juridicos: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
};

export default DatosGenerales;
